<template>
  <sidenav-right
    :show="isWebhook"
    :footer-dialog="true"
    :title="title"
    use-save
    @save="handleWebhook"
    @close="closeWebhook"
  >
    <template v-slot:content>
      <el-form
        :model="formWebhook"
        :rules="rules"
        ref="refFormWebhook"
        label-position="top"
      >
        <el-scrollbar height="80vh">
          <div class="mx-12">
            <el-form-item prop="url" class="mb-16">
              <span slots="label" class="font-12 mb-2">
                Callback URL
              </span>
              <el-input v-model="formWebhook.url" />
            </el-form-item>
            <div class="font-16 mb-8">Custom header</div>
            <el-form-item
              v-for="(item, index) in formWebhook.header_request"
              :key="index"
              :prop="'header_request.' + index + '.value'"
              class="mb-16"
            >
              <el-row>
                <el-col :span="11">
                  <span slots="label" class="font-12 mb-2">
                    Header
                  </span>
                  <el-input v-model="item.header" style="width: 94%;" />
                </el-col>
                <el-col :span="11">
                  <span slots="label" class="font-12 mb-2">
                    Value
                  </span>
                  <el-input v-model="item.value" style="width: 94%;" />
                </el-col>
                <el-col :span="2">
                  <el-icon
                    :size="16"
                    color="#F44336"
                    class="pointer ml-6 mt-28"
                    @click.prevent="removeHeader(item)">
                    <close-bold />
                  </el-icon>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button
                plain
                color="#0078CE"
                class="btn-add-webhook btn-full-block mt-2"
                @click="addHeader"
              >
                <el-icon
                  :size="18"
                  class="mr-4"
                >
                  <plus />
                </el-icon>
                <span class="font-w-semi-bold">
                  {{ $t('webhook.wb_add_more') }}
                </span>
              </el-button>
            </el-form-item>
          </div>
        </el-scrollbar>
      </el-form>
    </template>
  </sidenav-right>
</template>

<script setup>
import { webhookSave } from '@/api/endpoints/catalog/authOlsera.js'
import SidenavRight from '@/components/layout/SidenavRight.vue'
import { defineProps, defineEmits, onMounted, ref, reactive } from 'vue'
import { CloseBold, Plus } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps({
  isWebhook: {
    type: Boolean,
    default: false,
    required: true
  },
  title: {
    type: String,
    default: 'Title',
    required: true
  },
  data: {
    type: Object,
    default: () => {},
    required: true
  }
})

const emit = defineEmits([
  'closeWebhook',
  'simulateWebhoook',
  'loadWebhook'
])

const refFormWebhook = ref(null)
const formWebhook = reactive({
  url: '',
  header_request: []
})
const rules = reactive({
  url: [{ required: true, trigger: 'blur' }]
})

onMounted(() => {
  fetchData()
})

const fetchData = () => {
  formWebhook.url = props.data.webhook
  if (props.data.header_request) {
    props.data.header_request.forEach(item => {
      formWebhook.header_request.push(item)
    })
  }
}
const closeWebhook = () => {
  emit('closeWebhook')
}
const addHeader = () => {
  formWebhook.header_request.push({
    header: '',
    value: ''
  })
}
const removeHeader = (item) => {
  var index = formWebhook.header_request.indexOf(item)
  if (index !== -1) {
    formWebhook.header_request.splice(index, 1)
  }
}
const handleWebhook = () => {
  if (!refFormWebhook.value) return
  refFormWebhook.value.validate((valid) => {
    if (valid) {
      emit('closeWebhook')
      emit('loadWebhook', true)
      if (formWebhook.header_request.length === 0) {
        delete formWebhook.header_request
      }
      webhookSave(props.data.id, formWebhook).then(res => {
        setTimeout(() => {
          emit('loadWebhook', false)
          emit('simulateWebhoook', res)
          ElMessage({
            type: 'success',
            message: t('webhook.cb_success')
          })
        }, 2000)
      }).catch(err => {
        setTimeout(() => {
          emit('loadWebhook', false)
          emit('simulateWebhoook', err)
        }, 2000)
      })
    } else {
      ElMessage({
        type: 'warning',
        message: t('warning.complete_the_data')
      })
      return false
    }
  })
}
</script>
